import { Action } from '@ngrx/store';
import { Place, PremiumPlace } from '@polaris-customerweb/sharedcomponents.map';

export const PlaceAction = {
    setActivePointOfInterest: '[place] set active place',
    setActivePremiumPlace: '[place] set active premium place',
    setPlacesInView: '[place] set places in view',
};

export class SetActivePointOfInterest implements Action {
    type = PlaceAction.setActivePointOfInterest;
    constructor(public pointOfInterest: Place | undefined) {}
}

export class SetActivePremiumPoi implements Action {
    type = PlaceAction.setActivePremiumPlace;
    constructor(public place: PremiumPlace | undefined) {}
}

export class SetPlacesInView implements Action {
    type = PlaceAction.setPlacesInView;
    constructor(public places: Place[]) {}
}
